export class CustomerServicePriceOverride {

  public serviceId: string = "";
  public pricePerUnit: number = 0;
  public overridePricePerUnit: boolean = false;
  public minPrice: number = 0;
  public overrideMinPrice: boolean = false;

}
